export default function () {
  this.existsRegister('/v1/professional/steps/agendas/status', (data, meta) => {
    if (!data.addresses) {
      this.statusAddress = data.addresses
      this.statusPrice = data.price
      this.show = true
    }
    if (data.addresses && !data.price) {
      this.statusAddress = data.addresses
      this.statusPrice = data.price
      this.show = true
    }
    if (data.addresses && data.price) {
      this.statusAddress = data.addresses
      this.statusPrice = data.price
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/resources/mounted.js